import { render, staticRenderFns } from "./Spacer.vue?vue&type=template&id=1408b8f0&scoped=true&"
var script = {}
import style0 from "./Spacer.vue?vue&type=style&index=0&id=1408b8f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1408b8f0",
  null
  
)

export default component.exports